import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetRegistrarsMutation } from '../apis';
import type { RegistrarQueryLinkerSchema } from '../schemas';

export function RegistrarsAsyncSelect({ disabled, ...props }: FormAsyncComboboxProps<RegistrarQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: RegistrarQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }
      return (
        <PrimaryLink to="/settings/registrars/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetRegistrarsMutation}
      disabled={disabled}
    />
  );
}
